import TechnicianContentWrapper from './TechnicianContentWrapper'

export default TechnicianContentWrapper
